<template>
  <v-row no-gutters align="center" class="search-wrapper">
    <v-combobox
      ref="autocomplete"
      v-model="searchQuery"
      :items="items"
      :placeholder="pHolder | titlecase"
      :item-text="itemText"
      append-icon="search"
      :return-object="false"
      :no-filter="!filter"
      v-if="autocomplete"
      :loading="loading"
      @click:append="change"
      @change="change"
      @keyup="autocompleteChange"
      :autofocus="autofocus"
      :menu-props="{
        closeOnContentClick: true,
        maxWidth: 'min-content'
      }"
    >
      <template v-slot:item="{ item }">
        <slot name="item" :item="item">{{ item[itemText] }}</slot>
      </template>
      <template v-slot:no-data>
        <span></span>
      </template>
      <template v-slot:append v-if="loading">
        <v-progress-circular
          size="20"
          width="2"
          indeterminate
          small
          color="primary"
        ></v-progress-circular>
      </template>
    </v-combobox>
    <template v-else>
      <v-text-field
        v-model="searchQuery"
        :placeholder="pHolder | titlecase"
        solo
        text
        :loading="loading"
        append-icon="search"
        @click:append="change"
        @keyup.enter="change"
      ></v-text-field>
      <!-- <v-btn class="search-btn white--text" color="primary" @click="change()">
        <v-icon color="white">search</v-icon>
        {{$t("search")}}
      </v-btn>-->
    </template>
  </v-row>
</template>

<script>
export default {
  props: {
    autofocus: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String
    },
    items: {
      type: Array
    },
    itemText: {
      type: String,
      default: ""
    },
    autocomplete: {
      type: Boolean
    },
    filter: {
      type: Boolean,
      default: false
    },
    search: {
      type: Boolean
    },
    customText: {
      type: Function
    }
  },
  data: () => ({
    isOpen: false,
    loading: false,
    disabled: false,
    input: "",
    pHolder: null
  }),
  created() {
    this.searchQuery = this.value;
    this.pHolder = this.placeholder ? this.placeholder : this.$t("search");
  },
  watch: {
    autofocus(val) {
      if (val) {
        const DELAY = 500;
        setTimeout(() => {
          this.$refs.autocomplete.focus();
        }, DELAY);
      }
    },
    items: {
      deep: true,
      handler() {
        this.loading = false;
      }
    }
  },
  methods: {
    change(ev) {
      if (!this.disabled) {
        this.disabled = true;
        if (ev?.target) ev = ev.target.value;
        this.$emit("search", this.searchQuery);
        if (this.autocomplete) {
          this.loading = true;
          setTimeout(() => (this.loading = false), 3000);
        }
        setTimeout(() => {
          this.disabled = false;
        }, 1000);
      }
    },
    autocompleteChange(ev) {
      // do nothing if it's an arrow key
      let code = ev.keyCode || ev.which;
      if (ev?.target) ev = ev.target.value;
      this.input = ev;
      if (code === 13) {
        this.$emit("search", ev);
        this.$refs.autocomplete.blur();
      } else {
        this.$emit("autocomplete", ev);
        if (this.autocomplete) {
          this.loading = true;
          setTimeout(() => (this.loading = false), 3000);
        }
      }
    }
  }
};
</script>

<style scoped>
.search-wrapper {
  position: relative;
  width: 100%;
}

.v-autocomplete >>> .v-input__slot,
.v-text-field >>> .v-input__slot {
  background: white;
  padding: 5px !important;
  border-radius: 2px !important;
  flex: 1 1 100% !important;
}

.v-autocomplete >>> .v-input__slot::before {
  display: none;
}

.v-text-field {
  margin-top: 0;
  padding-top: 0;
}

.v-text-field >>> input {
  margin: 0;
}

.v-text-field >>> .v-input__slot {
  border-radius: 2px !important;
}

.v-text-field >>> .v-text-field__details {
  display: none;
}

.v-text-field >>> .v-input__append-inner .v-icon {
  color: var(--primary) !important;
}

.search-btn {
  width: 140px;
  height: 48px;
  /* transform: translateX(-140px); */
  margin-left: -140px;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  margin: 0 0 !important;
  box-shadow: unset !important;
}

.autocomplete-wrapper {
  position: relative;
}

.v-list.v-select-list {
  padding: 0;
}
</style>

<style>
.v-autocomplete__content > .v-select-list > .v-list {
  padding: 0 !important;
}
.v-autocomplete__content > .v-select-list > .v-list div > .v-list__tile {
  border-bottom: solid 0.3px #ccc !important;
}
.search-wrapper
  > .results-autocomplete
  > .v-input__control
  > .v-input__slot
  > .v-text-field__slot
  input {
  margin-top: 0px !important;
}

.v-autocomplete__content
  > .v-select-list
  > .v-list
  div:last-child
  > .v-list__tile {
  border-bottom: none !important;
}

/* .v-autocomplete__content > .v-select-list > .v-list div > .v-list__tile::before {
  background: url("../../../assets/icons/location-icon.png") no-repeat;
} */

.v-autocomplete__content {
  border-radius: 6px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px var(--white);
  background-color: var(--white);
}
</style>
